// assets/product-form.js

// ----- SHARED CART HELPERS (Nx-style) -----
function nxUpdateCartCount() {
  fetch('/')
    .then((response) => response.text())
    .then((html) => {
      var temp = document.createElement('div');
      temp.innerHTML = html;

      // This theme has multiple `id="cart-icon-bubble"` nodes (desktop/mobile/announcement).
      // Keep them all in sync.
      var newBubbles = temp.querySelectorAll('#cart-icon-bubble');
      var oldBubbles = document.querySelectorAll('#cart-icon-bubble');

      if (newBubbles && newBubbles.length && oldBubbles && oldBubbles.length) {
        oldBubbles.forEach(function (oldBubble, idx) {
          var newBubble = newBubbles[idx] || newBubbles[0];
          if (!newBubble || !oldBubble) return;
          oldBubble.innerHTML = newBubble.innerHTML;
        });
      }
    })
    .catch((e) => console.error('nxUpdateCartCount error', e));
}

function nxUpdateCartTotals(cart) {
  if (!cart) return;

  var totalPrice = cart.total_price; // cents
  // simple fallback formatter – replace with themeCurrency.formatMoney if you have it
  var formatted =
    typeof themeCurrency !== 'undefined' && theme && theme.moneyFormat
      ? themeCurrency.formatMoney(totalPrice, theme.moneyFormat)
      : (totalPrice / 100).toFixed(2);

  document.querySelectorAll('.cst-cart-total').forEach(function (el) {
    if (!el) return;
    el.setAttribute('data-original-price', formatted);
    var isVATIncluded = localStorage.getItem('vatPreference') !== 'exc';
    el.innerHTML = formatted + ' ' + (isVATIncluded ? 'Inc. VAT' : 'Excl. VAT');
  });
  document.querySelectorAll('.nx-price-vat-text').forEach(function (el) {
    if (!el) return;
    var isVATIncluded = localStorage.getItem('vatPreference') !== 'exc';
    el.textContent = (isVATIncluded ? 'Inc. VAT' : 'Excl. VAT');
  });
  if (typeof window.updateVatPrices === 'function') {
    window.updateVatPrices();
  }
}

function nxFetchCartAndUpdateUI() {
  return fetch('/cart.js')
    .then((r) => {
      const contentType = r.headers.get('content-type') || '';
      if (!r.ok || !contentType.includes('application/json')) {
        throw new Error(`cart.js request failed (${r.status})`);
      }
      return r.json();
    })
    .then((cart) => {
      nxUpdateCartTotals(cart);
      nxUpdateCartCount();
      return cart;
    })
    .catch((e) => console.error('nxFetchCartAndUpdateUI error', e));
}

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

        // Prefer cart-drawer first (more likely to be the Dawn component with the right methods)
        this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const submittedProductVariantId = formData.get('id');
        const extrasPayloadRaw = formData.get('properties[_extras_payload]');
        let extrasPayload = null;

        try {
          extrasPayload = extrasPayloadRaw ? JSON.parse(extrasPayloadRaw) : null;
        } catch (error) {
          extrasPayload = null;
        }

        // Keep base product line consistent so identical variant adds merge into one line item.
        formData.delete('properties[_extras_selection]');
        formData.delete('properties[_extras_payload]');
        formData.delete('properties[Handle pack]');
        formData.delete('properties[Door frame]');
        formData.delete('properties[Extras]');

        if (extrasPayload?.handlePack?.variantId || extrasPayload?.doorFrame?.variantId) {
          const baseVariantId = formData.get('id');
          const doorQuantity = parseInt(formData.get('quantity'), 10) || 1;
          const selectedExtras = [];
          if (extrasPayload.handlePack?.variantId) selectedExtras.push(extrasPayload.handlePack.variantId);
          if (extrasPayload.doorFrame?.variantId) selectedExtras.push(extrasPayload.doorFrame.variantId);

          // Use Shopify's multi-item payload shape for bundle adds.
          // Mixing top-level id/quantity with items[] can cause inconsistent responses.
          formData.delete('id');
          formData.delete('quantity');
          formData.append('items[0][id]', baseVariantId);
          formData.append('items[0][quantity]', doorQuantity);

          selectedExtras.forEach((variantId, index) => {
            formData.append(`items[${index + 1}][id]`, variantId);
            formData.append(`items[${index + 1}][quantity]`, doorQuantity);
          });
        }

        // Guard against non-Dawn cart elements / upgraded timing issues
        if (this.cart && typeof this.cart.getSectionsToRender === 'function') {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);

          if (typeof this.cart.setActiveElement === 'function') {
            this.cart.setActiveElement(document.activeElement);
          }
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then(async (rawResponse) => {
            const rawText = await rawResponse.text();
            let parsed = null;
            try {
              parsed = rawText ? JSON.parse(rawText) : null;
            } catch (e) {
              parsed = null;
            }

            if (!rawResponse.ok) {
              const fallbackMessage =
                rawResponse.status === 429
                  ? 'Too many requests. Please wait a few seconds and try again.'
                  : 'Unable to add this item to cart right now. Please try again.';

              const apiMessage =
                parsed?.description || parsed?.message || parsed?.errors || fallbackMessage;

              return {
                status: rawResponse.status,
                message: typeof apiMessage === 'string' ? apiMessage : fallbackMessage,
                errors: parsed?.errors || null,
              };
            }

            if (!parsed) {
              return {
                status: 500,
                message: 'Unexpected response while adding to cart. Please try again.',
                errors: null,
              };
            }

            return parsed;
          })
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: submittedProductVariantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description || response.message);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            // 🔹 Only redirect when there is NO cart element and NOT bg_update
            if (!this.cart && this.dataset.cartType !== 'bg_update') {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: submittedProductVariantId,
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;

            const quickAddModal = this.closest('quick-add-modal');

            // 🔹 If there IS a cart drawer/notification, keep the normal behavior
            if (this.cart && typeof this.cart.renderContents === 'function') {
              if (quickAddModal) {
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      CartPerformance.measure('add:paint-updated-sections', () => {
                        this.cart.renderContents(response);
                      });
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                CartPerformance.measure('add:paint-updated-sections', () => {
                  this.cart.renderContents(response);
                });
              }
            }

            if (!this.cart && this.dataset.cartType === 'bg_update') {
              nxFetchCartAndUpdateUI();
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent('add:user-action', evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
